import React, {
  createContext,
  useCallback,
  useReducer,
  useContext
} from 'react'
import axios from 'axios'
import { useUserAuthentication, useUserContext } from '@gopeerproject/chuck'
import { assertContext as assert, redirectToCore } from '@helpers'

export const AuthContext = createContext(null)

const initialState = {
  loading: true,
  user: null,
  profile: null
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET':
      return {
        [action.key]: action.value
      }
    case 'SET_MANY':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export const AuthContextProvider = ({ children }) => {
  const { mutate } = useUserAuthentication()
  const { token, setToken } = useUserContext()
  const [state, dispatch] = useReducer(reducer, initialState)

  const setState = useCallback(
    (key, value) => {
      if (key === 'token') {
        setToken(value)
        return
      }

      dispatch({
        type: 'SET',
        key,
        value
      })
    },
    [dispatch, setToken]
  )
  const { loading, user, profile } = state

  const identify = useCallback(
    () =>
      mutate(
        {},
        {
          onSuccess: (data) => {
            setToken(data.token)

            dispatch({
              type: 'SET_MANY',
              payload: {
                user: data.user,
                profile: data.profile,
                loading: false
              }
            })
          },
          onError: (err) => {
            if (axios.isAxiosError(err)) {
              redirectToCore(`/auth?auth_redirect=${window.location.href}`)
            }
            console.error(err)
          }
        }
      ),
    [mutate, setToken, dispatch]
  )

  return (
    <AuthContext.Provider
      value={{ user, profile, token, loading, identify, setState, setToken }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = () => {
  const context = useContext(AuthContext)
  assert(context, 'useAuthContext', 'AuthContextProvider')
  return context
}
